import React from "react";
import { View, StyleSheet } from "react-native";

import colors from "@constants/color";
import Text from "@components/CustomText";
import Calendar from "@assets/svg/MyTasks/Calendar";

interface Props {
  timeSlot: string;
}

const TimeSlotTag = ({ timeSlot }: Props) => {
  return (
    <View style={styles.timeSlotedTag}>
      <Calendar />
      <Text
        variant="caption_1"
        style={{ color: colors.plain_red, lineHeight: 18, marginLeft: 6 }}
      >
        {timeSlot}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  timeSlotedTag: {
    flexDirection: "row",
    backgroundColor: colors.white,
    borderRadius: 18,
    alignItems: "center",
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
});

export default TimeSlotTag;
